import React from "react";

import ContentBelow from "../../../components/ContentBelow";
import blogData from "../data";
import Button from "../../../components/Button";

export default function Template1({ data }) {
  if (!data) return <p>No data found for Blog</p>;

  return (
    <div className="">
      {data.MainHeading && <h1>{data.MainHeading}</h1>}
      {data.IntroductionP && <p>{data.IntroductionP}</p>}
      {data.Subheading1 && (
        <>
          <h3>{data.Subheading1}</h3>
        </>
      )}
      {data.Subp1 && (
        <>
          {data.Subp1.map((p) => (
            <>
              <p>{p.p1}</p>
              <p>{p.p2}</p>
              <p>{p.p3}</p>
              <p>{p.p4}</p>
            </>
          ))}
        </>
      )}
      {data.Subheading2 && (
        <>
          <h3>{data.Subheading2}</h3>
        </>
      )}
      {data.Subp2 && (
        <>
          {data.Subp2.map((p) => (
            <>
              <p>{p.p1}</p>
              <p>{p.p2}</p>
              <p>{p.p3}</p>
              <p>{p.p4}</p>
            </>
          ))}
        </>
      )}
      {data.Subheading3 && (
        <>
          <h3>{data.Subheading3}</h3>
        </>
      )}
      {data.Subp3 && (
        <>
          {data.Subp3.map((p) => (
            <>
              <p>{p.p1}</p>
              <p>{p.p2}</p>
              <p>{p.p3}</p>
              <p>{p.p4}</p>
            </>
          ))}
        </>
      )}
      {data.Subheading4 && (
        <>
          <h3>{data.Subheading4}</h3>
          <p>{data.Subp4}</p>
          <div className=" btn-group">
            {data.WhatsAppbutton && (
              <button
                className="btn btn-primary"
                onClick={() =>
                  window.open("https://wa.me/+27630680075", "_blank")
                }
              >
                WhatsApp
              </button>
            )}
          </div>
          <div className=" btn-group m-2">
            {data.Emailbutton && (
              <button
                className="btn btn-primary"
                onClick={() =>
                  window.open("mailto:apply@webridge.co.za", "_blank")
                }
              >
                Email
              </button>
            )}
          </div>
        </>
      )}
      {data.Subheading5 && (
        <>
          <h3>{data.Subheading5}</h3>
          <p>{data.Subp5}</p>
        </>
      )}
    </div>
  );
}
